
import RoleTemplatePortalRoleLnkHashTableTypes from "../types/hashTableTypes/RoleTemplatePortalRoleLnkHashTableTypes"
import PortalRoleTypes from "../types/portalRoleTypes/PortalRoleTypes"
import RoleTemplatePortalRoleLinkPermissionsBoiler from "./boilerPlates/templateBoilerplates/RoleTemplatePortalRoleLinkPermissionsBoiler"
import PortalRoleTemplatePortalRoleLnkBoilerplate from "./boilerPlates/templateBoilerplates/PortalRoleTemplatePortalRoleLnkBoilerplate"
import ratmHash from "./RATMHash"

const handleAddOrDropRoleInTemplate = (role: PortalRoleTypes) => {

    const linkedFromHash: RoleTemplatePortalRoleLnkHashTableTypes = ratmHash.lookupHashTableItem(role.PortalRoleId, 2)

    if (linkedFromHash) {
        let permissions = linkedFromHash[2].permissions
        let newLink = linkedFromHash
        if (permissions.hasRole && !permissions.dropRole) {
            permissions.dropRole = true
        } else if (permissions.hasRole && permissions.dropRole) {
            permissions.dropRole = false
            permissions.addView = false
            permissions.addEdit = false
        }

        if (!permissions.hasRole && !permissions.addRole) {
            permissions.addRole = true
            permissions.addView = true
        } else if (!permissions.hasRole && permissions.addRole) {
            permissions.addRole = false
            permissions.addView = false
            permissions.addEdit = false
            if(!linkedFromHash[1].RoleTemplatePortalRoleLnk.RoleTemplatePortalRoleLnkId){
                ratmHash.deleteHashTableItem(linkedFromHash, 2)
            }
        }
        ratmHash.updateHashTableItem(newLink, 2, true)
    } else {
        let newPermissions = JSON.parse(JSON.stringify(RoleTemplatePortalRoleLinkPermissionsBoiler))
        newPermissions.addRole = true
        newPermissions.addView = true

        let newLink: RoleTemplatePortalRoleLnkHashTableTypes = [
            `${role.PortalRoleId}`,
            { RoleTemplatePortalRoleLnk: JSON.parse(JSON.stringify(PortalRoleTemplatePortalRoleLnkBoilerplate)) },
            { permissions: newPermissions },
            { modified: false }
        ]
        newLink[1].RoleTemplatePortalRoleLnk.View = true
        ratmHash.addHashTableItem(newLink, 2)
    }
    // console.log("link storage", ratmHash.getStorage(2).filter(n => n))
}

export default handleAddOrDropRoleInTemplate